import TennisTable from "./TennisTable";

export const secondPickleBallSection = (n) => {
  return [
    {
      name: "Row 2",
      left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
      right: [
        {
          column1: "One Coat/Two Coats",
          column2: `${43 * n} Gallons / ${86 * n} Gallons`,
        },
        {
          column1: "One Coat/Two Coats",
          column2: `${65 * n} Gallons / ${128 * n} Gallons`,
        },
      ],
    },
  ];
};

export const thirdPickleBallSection = (n) => {
  return [
    {
      name: "Row 3",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${7.5 * n} Gallons` },
      ],
    },
  ];
};

export const forthPickleBallSection = (n) => {
  return [
    {
      name: "Row 4",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${55 * n} Gallons` },
        { column1: "Two Coats", column2: `${77.5 * n} Gallons` },
        { column1: "Two Coats", column2: `${100 * n} Gallons` },
      ],
    },
  ];
};

export const fifthPickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
      ],
    },
  ];
};

export const sixthPickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
      ],
    },
  ];
};

export const seventhPickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${15 * n} Gallons` },
        { column1: "Two Coats", column2: `${25 * n} Gallons` },
        { column1: "Two Coats", column2: `${30 * n} Gallons` },
      ],
    },
  ];
};

export const eightPickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
      ],
    },
  ];
};

export const ninePickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Stripe Rite",
        "White Line Paint",
        "Masking Tape",
        "Standard Size Roll",
      ],
      right: [
        { column1: "One Coat", column2: `${1 * n} Gallons` },
        { column1: "One Coat", column2: `${1 * n} Gallons` },
        { column1: "Rolls Needed", column2: `` },
        { column1: "6", column2: `` },
      ],
    },
  ];
};

const BasketBallCourtNBA = ({ n }) => {
  const renderCourt = (numberOfCourt) => {
    switch (numberOfCourt) {
      case "one-option":
        return 1;
      case "2-option":
        return 2;
      case "three-option":
        return 3;
      case "four-horizontal-option-2":
        return 4;
      case "four-vertical-option":
        return 4;
      case "five-option-2":
        return 5;
      case "six-horizontal-option-2":
        return 6;
      case "six-vertical-option-3":
        return 6;
      case "seven-option-2":
        return 7;
      case "eight-horizontal-option-2":
        return 8;
      case "eight-vertical-option-2":
        return 8;
      default:
        return 1;
    }
  };
  return (
    <>
      <TennisTable
        rows={secondPickleBallSection(renderCourt(n))}
        leftCol={"Total Area  4752 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={thirdPickleBallSection(renderCourt(n))}
        leftCol={"Boarder 568 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={forthPickleBallSection(renderCourt(n))}
        leftCol={"Court 8400 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={fifthPickleBallSection(renderCourt(n))}
        leftCol={"Key 460 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={sixthPickleBallSection(renderCourt(n))}
        leftCol={"Top Of Key 116 sq ft Per Side"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={seventhPickleBallSection(renderCourt(n))}
        leftCol={"3 Point Area 1872 sq ft Per Side"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={eightPickleBallSection(renderCourt(n))}
        leftCol={"Center Circle 230 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={ninePickleBallSection(renderCourt(n))}
        leftCol={"Striping"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
    </>
  );
};

export default BasketBallCourtNBA;
